import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RJobCategory } from './r-job-category-area.action';

interface RJobCategoryXsStateModel {
  viewGlobalJobCategory: string;
  createGlobalJobCategory: string;
  editGlobalJobCategory: string;
  deleteGlobalJobCategory: string;

}

const getDefaults = (): RJobCategoryXsStateModel => ({
  viewGlobalJobCategory: null,
  createGlobalJobCategory: null,
  editGlobalJobCategory: null,
  deleteGlobalJobCategory: null,

});

@State<RJobCategoryXsStateModel>({
  name: 'rJobCategory',
  defaults: getDefaults()
})
@Injectable()
export class RJobCategoryXsState {

  //region SELECTOR
  @Selector()
  static canViewGlobalJobCategory(state: RJobCategoryXsStateModel): boolean {
    return state.viewGlobalJobCategory != null;
  }

  @Selector()
  static canCreateGlobalJobCategory(state: RJobCategoryXsStateModel): boolean {
    return state.createGlobalJobCategory != null;
  }

  @Selector()
  static canEditGlobalJobCategory(state: RJobCategoryXsStateModel): boolean {
    return state.editGlobalJobCategory != null;
  }

  @Selector()
  static canDeleteGlobalJobCategory(state: RJobCategoryXsStateModel): boolean {
    return state.deleteGlobalJobCategory != null;
  }

  //endregion

  //region ACTIONS
  @Action(RJobCategory.SetJobCategoryPrivileges)
  public setJobCategoryPrivileges(ctx: StateContext<RJobCategoryXsStateModel>, action: RJobCategory.SetJobCategoryPrivileges) {
    const state = ctx.getState();
    const designationPrivileges = [...action.activeUserRightInfoDtoModel.designationPrivileges];

    //find user privilege data model
    const viewGlobalJobCategory = designationPrivileges.find(id => id === UserPrivilegeEnum.VIEW_GLOBAL_JOB_CATEGORIES);
    const createGlobalJobCategory = designationPrivileges.find(id => id === UserPrivilegeEnum.CREATE_GLOBAL_JOB_CATEGORY);
    const editGlobalJobCategory = designationPrivileges.find(id => id === UserPrivilegeEnum.EDIT_GLOBAL_JOB_CATEGORY);
    const deleteGlobalJobCategory = designationPrivileges.find(id => id === UserPrivilegeEnum.DELETE_GLOBAL_JOB_CATEGORY);

    //set the state
    ctx.setState({
      ...state,
      viewGlobalJobCategory: viewGlobalJobCategory,
      createGlobalJobCategory: createGlobalJobCategory,
      editGlobalJobCategory: editGlobalJobCategory,
      deleteGlobalJobCategory: deleteGlobalJobCategory
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RJobCategoryXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
}
//endregion
